// Fix for dynamically injected elements causing 32px white bar at top
// This script hides elements that appear before the header-group to prevent layout issues
(function() {
  'use strict';
  
  /** @type {MutationObserver | null} */
  let observer = null;
  
  /**
   * Hide elements that appear before header-group
   */
  function hideElementsBeforeHeader() {
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;
    
    // Get all body children before header-group
    const bodyChildren = Array.from(document.body.children);
    const headerGroupIndex = bodyChildren.indexOf(headerGroup);
    
    // Hide any elements before header-group (except skip link and scripts)
    bodyChildren.slice(0, headerGroupIndex).forEach((el) => {
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
      if (el.classList.contains('skip-to-content-link')) return;
      
      // Use CSS class instead of inline styles with !important
      el.classList.add('fix-top-spacing-hidden');
    });
  }
  
  /**
   * Initialize the observer
   */
  function initObserver() {
    // Clean up existing observer if any
    if (observer) {
      observer.disconnect();
    }
    
    observer = new MutationObserver(() => {
      hideElementsBeforeHeader();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: false
    });
  }
  
  /**
   * Clean up observer on page unload
   */
  function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }
  
  // Run immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      hideElementsBeforeHeader();
      initObserver();
    });
  } else {
    hideElementsBeforeHeader();
    initObserver();
  }
  
  // Clean up on page unload/navigation
  window.addEventListener('beforeunload', cleanup);
  
  // Support for view transitions (Shopify theme feature)
  if (window.Shopify?.designMode) {
    // In design mode, keep observer running
  } else {
    // On page navigation, cleanup
    window.addEventListener('pageswap', cleanup);
  }
})();

